"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("./../../Modal"));
var _Title = _interopRequireDefault(require("../../Title"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// import Toast from './../../../Toast';
function index(props) {
  var btnConfiguration = props.btnConfiguration,
    leftTitle = props.leftTitle,
    leftContent = props.leftContent,
    leftRuleTxt = props.leftRuleTxt,
    onCallback = props.onCallback,
    rightList = props.rightList,
    btnTxt = props.btnTxt,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    colorTheme = props.colorTheme,
    backgroundPic = props.backgroundPic,
    backgroundPicMo = props.backgroundPicMo,
    extendProps = props.extendProps;
  var backgroundPicUrl = (0, _utils.fomateFileData)(backgroundPic).url;
  var backgroundPicMoUrl = (0, _utils.fomateFileData)(backgroundPicMo).url;
  var _b = btnConfiguration || {},
    list = _b.list,
    modalTitle = _b.modalTitle,
    richTextContent = _b.richTextContent;
  var _c = (0, _react.useState)(''),
    modalContent = _c[0],
    setModalContent = _c[1];
  var _d = (0, _react.useState)(false),
    status = _d[0],
    setStatus = _d[1];
  var _e = (0, _react.useState)({}),
    modalList = _e[0],
    setModalList = _e[1];
  var newRightList = rightList;
  if ((rightList === null || rightList === void 0 ? void 0 : rightList.length) > 3) {
    newRightList = rightList.slice(0, 3);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'specialoffers-containermax',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, (props === null || props === void 0 ? void 0 : props.mainTitle) ? /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: props === null || props === void 0 ? void 0 : props.mainTitle
  }) : null, (props === null || props === void 0 ? void 0 : props.smallTitle) ? /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'container__h4'
  }, props === null || props === void 0 ? void 0 : props.smallTitle) : null, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'aduio-video-specialoffers-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-specialoffers-wrap',
    style: backgroundPicUrl ? {
      background: "url(" + backgroundPicUrl + ") no-repeat",
      backgroundSize: '100% 100%'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('aduio-video-specialoffers-wrap-left', {
      studentleft: colorTheme === 'studentactivities',
      hasTxt: rightList.find(function (item) {
        return item.txt;
      })
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "specialoffers-left-header"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: (0, _classnames["default"])('specialoffers-left-title', {
      studenttitlecolor: colorTheme === 'studentactivities',
      hasTxt: rightList.find(function (item) {
        return item.txt;
      })
    })
  }, leftTitle), leftRuleTxt ? ( /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('specialoffers-left-rule', {
      studentrulecolor: colorTheme === 'studentactivities'
    })
  }, extendProps || {}, {
    onClick: function onClick() {
      setStatus(true);
      setModalList({
        list: list,
        modalTitle: modalTitle
      });
      setModalContent(richTextContent);
    }
  }), leftRuleTxt)) : null), leftContent ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('specialoffers-left-content', {
      studentcontentcolor: colorTheme === 'studentactivities',
      hasTxt: rightList.find(function (item) {
        return item.txt;
      })
    })
  }, leftContent)) : null, /*#__PURE__*/_react["default"].createElement("button", __assign({
    className: (0, _classnames["default"])('specialoffers-left-btn', {
      studentcolor: colorTheme === 'studentactivities',
      hasTxt: rightList.find(function (item) {
        return item.txt;
      })
    })
  }, extendProps || {}, {
    onClick: function onClick() {
      onCallback && onCallback();
    }
  }), btnTxt)), /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('aduio-video-specialoffers-wrap-right', {
      studentright: colorTheme === 'studentactivities'
    })
  }, newRightList === null || newRightList === void 0 ? void 0 : newRightList.map(function (item, index) {
    var rightTitle = item.rightTitle,
      txt = item.txt,
      num = item.num;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: colorTheme === 'studentactivities' ? 'students-li' : '',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('specialoffers-right-item', {
        'student-line': colorTheme === 'studentactivities'
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('specialoffers-right-title', {
        hasTxt: txt
      })
    }, rightTitle), txt ? /*#__PURE__*/_react["default"].createElement("div", {
      className: 'specialoffers-right-txt'
    }, txt) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('specialoffers-right-num', {
        studentnumcolor: colorTheme === 'studentactivities'
      })
    }, num)));
  })))), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'aduio-video-specialoffers-container-wrap-mo'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('aduio-video-specialoffers-container-mo'),
    style: backgroundPicMoUrl ? {
      background: "url(" + backgroundPicMoUrl + ") no-repeat",
      backgroundSize: '100% 100%'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: (0, _classnames["default"])('specialoffers-left-title-mo', {
      'students-title-mo': colorTheme === 'studentactivities'
    })
  }, leftTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('specialoffers-left-content-mo', {
      'students-content-color-mo': colorTheme === 'studentactivities'
    })
  }, leftContent), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('specialoffers-left-rule-mo', {
      'students-rule-color-mo': colorTheme === 'studentactivities'
    }),
    onClick: function onClick() {
      setStatus(true);
      setModalList({
        list: list,
        modalTitle: modalTitle
      });
      setModalContent(richTextContent);
    }
  }, extendProps || {}), leftRuleTxt), /*#__PURE__*/_react["default"].createElement("ul", null, newRightList === null || newRightList === void 0 ? void 0 : newRightList.map(function (item, index) {
    var rightTitle = item.rightTitle,
      txt = item.txt,
      num = item.num;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'specialoffers-right-item-mo'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'specialoffers-right-title-mo'
    }, rightTitle), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'specialoffers-right-txtnum-mo'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'specialoffers-right-txt-mo'
    }, txt), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('specialoffers-right-num-mo', {
        'students-num-mo': colorTheme === 'studentactivities'
      })
    }, num))));
  })), /*#__PURE__*/_react["default"].createElement("button", __assign({
    className: (0, _classnames["default"])('specialoffers-left-btn', {
      studentcolormo: colorTheme === 'studentactivities'
    })
  }, extendProps || {}, {
    onClick: function onClick() {
      onCallback && onCallback();
    }
  }), btnTxt))), status && ( /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    close: function close() {
      setStatus(false);
    },
    submit: function submit() {
      setStatus(false);
    },
    modalList: modalList,
    modalContent: modalContent
  })));
}